import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Button,
  Typography,
  ButtonBase,
} from '@material-ui/core'
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt'
import ThumbUpAltOutlined from '@material-ui/icons/ThumbUpAltOutlined'

// import RsvpIcon from '@mui/icons-material/Rsvp';

import rsvpimg from '../../../images/rsvpp.jpeg'

import DeleteIcon from '@material-ui/icons/Delete'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import moment from 'moment'

import { deletePost, likePost } from '../../../actions/posts'
import useStyles from './styles.js'

const Post = ({ post, setCurrentId }) => {
  const [likes, setLikes] = useState(post?.likes)
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  const user = JSON.parse(localStorage.getItem('profile'))

  const userId = user?.result?.googleId || user?.result?._id
  const hasLikedPost = likes.find((like) => like === userId)

  const openPost = () => history.push(`/posts/${post._id}`)

  const handleLike = async () => {
    dispatch(likePost(post._id))

    if (hasLikedPost) {
      setLikes(likes.filter((id) => id !== userId))
    } else {
      setLikes([...likes, userId])
    }
  }

  const Likes = () => {
    if (likes.length > 0) {
      return likes.find((like) => like === userId) ? (
        <>
          {/* <ThumbUpAltIcon fontSize="small" /> */}
          
          <img src={rsvpimg} alt="RSVP" style={{ width: '24px', height: '24px' }} />

          
          &nbsp;
          {likes.length > 2
            ? `You and ${likes.length - 1} others`
            : `${likes.length} RSVP${likes.length > 1 ? 's' : ''}`}
        </>
      ) : (
        <>
          {/* <ThumbUpAltOutlined fontSize="small" /> */}
         
          <img src={rsvpimg} alt="RSVP" style={{ width: '24px', height: '24px', filter: 'grayscale(100%)' }} />

         
          &nbsp;{likes.length} {likes.length === 1 ? 'RSVP' : 'RSVPs'}
        </>
      )
    }

    return (
      <>
        {/* <ThumbUpAltOutlined fontSize="small" /> */}

        <img src={rsvpimg} alt="RSVP" style={{ width: '24px', height: '24px', filter: 'grayscale(100%)' }} />

        &nbsp;RSVP
      </>
    )
  }

  return (
    <Card className={classes.card} raised elevation={6}>
      <ButtonBase className={classes.cardAction} >
        <CardMedia onClick={openPost}
          className={classes.media}
          image={post.selectedFile}
          title={post.title}
        />
        <div className={classes.overlay}>
          <Typography onClick={openPost} variant="h6" className={classes.boldText}>{post.name} </Typography>
          <Typography variant="body2" >
            Listed {moment(post.createdAt).fromNow()}
          </Typography>
        </div>
        {(user?.result?.googleId === post?.creator ||
          user?.result?._id === post?.creator) && (
          <div className={classes.overlay2}>
            <Button
              style={{ color: 'white' }}
              size="small"
              onClick={() => setCurrentId(post._id)}
            >
              <MoreHorizIcon fontSize="medium" />
            </Button>
          </div>
        )}
        <div className={classes.details} onClick={openPost}>
          <Typography variant="body2" color="textSecondary">
            
          Location: <a 
  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(post.tags)}`}
  target="_blank"
  rel="noopener noreferrer"
  style={{ color: '#FACE3', textDecoration: 'underline', fontWeight: 'bold' }}
      

>
            
             {post.tags}
            </a>

             {/* {post.tags.map((tag) => `${tag} `)} */}
          </Typography>
        </div>
        <Typography className={`${classes.title} ${classes.boldText}`} variant="h5" gutterBottom onClick={openPost}>
          {post.title}
        </Typography>
        <CardContent>
          <Typography variant="body2" color="textSecondary" component="p" onClick={openPost} className={classes.clampText}>
            {post.message}
          </Typography>
        </CardContent>
      </ButtonBase>
      <CardActions className={classes.cardActions}>
        <Button
          size="small"
          color="primary"
          disabled={!user?.result}
          onClick={handleLike}
        >
          <Likes />
        </Button>
        {(user?.result?.googleId === post?.creator ||
          user?.result?._id === post?.creator) && (
          <Button
            size="small"
            color="primary"
            onClick={() => dispatch(deletePost(post._id))}
          >
            <DeleteIcon fontSize="small" />
            Delete
          </Button>
        )}
      </CardActions>
    </Card>
  )
}

export default Post
